// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Coordinate$YourProjectName from "../coordinate/coordinate.bs.js";
import * as Cell_selector$YourProjectName from "./cell_selector.bs.js";

var include = Cell_selector$YourProjectName.MakeCellSelector({
      name: Coordinate$YourProjectName.name,
      render: Coordinate$YourProjectName.render
    });

var empty = include.empty;

var make = include.make;

export {
  empty ,
  make ,
  
}
/* include Not a pure module */
